import React, { Component } from 'react';
import { connect } from "react-redux";
import {updateParameter} from 'operations/actions.js';

class OscillatorOption extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    enableOscillator() {
        this.props.sequencerEngine.operationManager.dispatch(
            updateParameter(this.props.oscillator.enabledParameter, true));
        this.setState(this.state);
    }

    disableOscillator() {
        this.props.sequencerEngine.operationManager.dispatch(
            updateParameter(this.props.oscillator.enabledParameter, false));
        this.setState(this.state);
    }

    onClick() {
        if (this.props.oscillator.enabled) {
            if (this.props.selectedOscillator === this.props.number) {
                this.disableOscillator();
            } else {
                this.props.onChooseOscillator(this.props.number);
            }
        } else {
            this.enableOscillator();
            this.props.onChooseOscillator(this.props.number);
        }
    }

    render() {
        let className = this.props.number === this.props.selectedOscillator ?
            'oscillator-option selected' : 'oscillator-option';

        if (!this.props.enabled) {
            className += ' disabled';
        }

        return (
            <div
              onClick={() => this.onClick()}
              className={className}>
              {this.props.number + 1}
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    let enabledParameter = props.oscillator.enabledParameter;
    let enabled = state.effects.effectParameters[enabledParameter.id];
    return {
        enabled: enabled
    }
};

export default connect(mapStateToProps, null)(OscillatorOption);
